import styled from "styled-components";
import { Radio } from "@material-ui/core";
import { colors } from "../../styles/global";

export const StyledRadio = styled(Radio)`
    &.Mui-checked {
        color: ${colors.brightGreen};
    }
`